export const formatTime = (ms: number): string => {
  if (ms < 1000) return `${ms.toFixed(0)}ms`;
  return `${(ms / 1000).toFixed(2)}s`;
};

export const formatNumber = (num: number): string => {
  return new Intl.NumberFormat().format(num);
};
